"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = exports.MTableHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableSortLabel = _interopRequireDefault(require("@material-ui/core/TableSortLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _core = require("@material-ui/core");
var CommonValues = _interopRequireWildcard(require("../utils/common-values"));
var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

class MTableHeader extends React.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "handleMouseDown", (e, columnDef) => {
      this.setState({
        lastAdditionalWidth: columnDef.tableData.additionalWidth,
        lastX: e.clientX,
        resizingColumnDef: columnDef
      });
    });
    (0, _defineProperty2.default)(this, "handleMouseMove", e => {
      if (!this.state.resizingColumnDef) {
        return;
      }
      let additionalWidth = this.state.lastAdditionalWidth + e.clientX - this.state.lastX;
      additionalWidth = Math.min(this.state.resizingColumnDef.maxWidth || additionalWidth, additionalWidth);
      if (this.state.resizingColumnDef.tableData.additionalWidth !== additionalWidth) {
        this.props.onColumnResized(this.state.resizingColumnDef.tableData.id, additionalWidth);
      }
    });
    (0, _defineProperty2.default)(this, "handleMouseUp", e => {
      this.setState({
        resizingColumnDef: undefined
      });
    });
    (0, _defineProperty2.default)(this, "getCellStyle", columnDef => {
      const width = CommonValues.reducePercentsInCalc(columnDef.tableData.width, this.props.scrollWidth);
      const style = (0, _objectSpread2.default)({}, this.props.headerStyle, columnDef.headerStyle, {
        boxSizing: "border-box",
        width,
        maxWidth: columnDef.maxWidth,
        minWidth: columnDef.minWidth
      });
      if (this.props.options.tableLayout === "fixed" && this.props.options.columnResizable && columnDef.resizable !== false) {
        style.paddingRight = 2;
      }
      return style;
    });
    this.state = {
      lastX: 0,
      resizingColumnDef: undefined
    };
  }

  // shouldComponentUpdate(nextProps, nextState){
  //   return !equal(nextProps, this.props) || !equal(nextState, this.state);
  // }

  componentDidMount() {
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("mouseup", this.handleMouseUp);
  }
  componentWillUnmount() {
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("mouseup", this.handleMouseUp);
  }
  renderHeader() {
    const size = this.props.options.padding === "default" ? "medium" : "small";
    const mapArr = this.props.columns.filter(columnDef => !columnDef.hidden && !(columnDef.tableData.groupOrder > -1)).sort((a, b) => a.tableData.columnOrder - b.tableData.columnOrder).map((columnDef, index) => {
      let content = columnDef.title;
      if (this.props.draggable) {
        content = /*#__PURE__*/React.createElement(_reactBeautifulDnd.Draggable, {
          key: columnDef.tableData.id,
          draggableId: columnDef.tableData.id.toString(),
          index: index
        }, (provided, snapshot) => /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
          ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps), columnDef.title));
      }
      if (columnDef.sorting !== false && this.props.sorting) {
        content = /*#__PURE__*/React.createElement(_TableSortLabel.default, {
          IconComponent: this.props.icons.SortArrow,
          active: this.props.orderBy === columnDef.tableData.id,
          direction: this.props.orderDirection || "asc",
          onClick: () => {
            const orderDirection = columnDef.tableData.id !== this.props.orderBy ? "asc" : this.props.orderDirection === "asc" ? "desc" : this.props.orderDirection === "desc" && this.props.thirdSortClick ? "" : this.props.orderDirection === "desc" && !this.props.thirdSortClick ? "asc" : this.props.orderDirection === "" ? "asc" : "desc";
            this.props.onOrderChange(columnDef.tableData.id, orderDirection);
          }
        }, content);
      }
      if (columnDef.tooltip) {
        content = /*#__PURE__*/React.createElement(_core.Tooltip, {
          title: columnDef.tooltip,
          placement: "bottom"
        }, /*#__PURE__*/React.createElement("span", null, content));
      }
      if (this.props.options.tableLayout === "fixed" && this.props.options.columnResizable && columnDef.resizable !== false) {
        content = /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, content), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(this.props.icons.Resize, {
          style: {
            cursor: "col-resize",
            color: this.state.resizingColumnDef && this.state.resizingColumnDef.tableData.id === columnDef.tableData.id ? this.props.theme.palette.primary.main : "inherit"
          },
          onMouseDown: e => this.handleMouseDown(e, columnDef)
        }));
      }
      const cellAlignment = columnDef.align !== undefined ? columnDef.align : ["numeric", "currency"].indexOf(columnDef.type) !== -1 ? "right" : "left";
      return /*#__PURE__*/React.createElement(_TableCell.default, {
        key: columnDef.tableData.id,
        align: cellAlignment,
        className: this.props.classes.header,
        style: this.getCellStyle(columnDef),
        size: size
      }, content);
    });
    return mapArr;
  }
  renderActionsHeader() {
    const localization = (0, _objectSpread2.default)({}, MTableHeader.defaultProps.localization, this.props.localization);
    const width = CommonValues.actionsColumnWidth(this.props);
    return /*#__PURE__*/React.createElement(_TableCell.default, {
      key: "key-actions-column",
      padding: "checkbox",
      className: this.props.classes.header,
      style: (0, _objectSpread2.default)({}, this.props.headerStyle, {
        width: width,
        textAlign: "center",
        boxSizing: "border-box"
      })
    }, /*#__PURE__*/React.createElement(_TableSortLabel.default, {
      hideSortIcon: true,
      disabled: true
    }, localization.actions));
  }
  renderSelectionHeader() {
    const selectionWidth = CommonValues.selectionMaxWidth(this.props, this.props.treeDataMaxLevel);
    return /*#__PURE__*/React.createElement(_TableCell.default, {
      padding: "none",
      key: "key-selection-column",
      className: this.props.classes.header,
      style: (0, _objectSpread2.default)({}, this.props.headerStyle, {
        width: selectionWidth
      })
    }, this.props.showSelectAllCheckbox && /*#__PURE__*/React.createElement(_Checkbox.default, (0, _extends2.default)({
      indeterminate: this.props.selectedCount > 0 && this.props.selectedCount < this.props.dataCount,
      checked: this.props.dataCount > 0 && this.props.selectedCount === this.props.dataCount,
      onChange: (event, checked) => this.props.onAllSelected && this.props.onAllSelected(checked)
    }, this.props.options.headerSelectionProps)));
  }
  renderDetailPanelColumnCell() {
    return /*#__PURE__*/React.createElement(_TableCell.default, {
      padding: "none",
      key: "key-detail-panel-column",
      className: this.props.classes.header,
      style: (0, _objectSpread2.default)({}, this.props.headerStyle)
    });
  }
  render() {
    const headers = this.renderHeader();
    if (this.props.hasSelection) {
      headers.splice(0, 0, this.renderSelectionHeader());
    }
    if (this.props.showActionsColumn) {
      if (this.props.actionsHeaderIndex >= 0) {
        let endPos = 0;
        if (this.props.hasSelection) {
          endPos = 1;
        }
        headers.splice(this.props.actionsHeaderIndex + endPos, 0, this.renderActionsHeader());
      } else if (this.props.actionsHeaderIndex === -1) {
        headers.push(this.renderActionsHeader());
      }
    }
    if (this.props.hasDetailPanel) {
      if (this.props.detailPanelColumnAlignment === "right") {
        headers.push(this.renderDetailPanelColumnCell());
      } else {
        headers.splice(0, 0, this.renderDetailPanelColumnCell());
      }
    }
    if (this.props.isTreeData > 0) {
      headers.splice(0, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "none",
        key: "key-tree-data-header",
        className: this.props.classes.header,
        style: (0, _objectSpread2.default)({}, this.props.headerStyle)
      }));
    }
    this.props.columns.filter(columnDef => columnDef.tableData.groupOrder > -1).forEach(columnDef => {
      headers.splice(0, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "checkbox",
        key: "key-group-header" + columnDef.tableData.id,
        className: this.props.classes.header
      }));
    });
    return /*#__PURE__*/React.createElement(_TableHead.default, null, /*#__PURE__*/React.createElement(_TableRow.default, null, headers));
  }
}
exports.MTableHeader = MTableHeader;
MTableHeader.defaultProps = {
  dataCount: 0,
  hasSelection: false,
  headerStyle: {},
  selectedCount: 0,
  sorting: true,
  localization: {
    actions: "Actions"
  },
  orderBy: undefined,
  orderDirection: "asc",
  actionsHeaderIndex: 0,
  detailPanelColumnAlignment: "left",
  draggable: true,
  thirdSortClick: true
};
MTableHeader.propTypes = {
  columns: _propTypes.default.array.isRequired,
  dataCount: _propTypes.default.number,
  hasDetailPanel: _propTypes.default.bool.isRequired,
  detailPanelColumnAlignment: _propTypes.default.string,
  hasSelection: _propTypes.default.bool,
  headerStyle: _propTypes.default.object,
  localization: _propTypes.default.object,
  selectedCount: _propTypes.default.number,
  sorting: _propTypes.default.bool,
  onAllSelected: _propTypes.default.func,
  onOrderChange: _propTypes.default.func,
  orderBy: _propTypes.default.number,
  orderDirection: _propTypes.default.string,
  actionsHeaderIndex: _propTypes.default.number,
  showActionsColumn: _propTypes.default.bool,
  showSelectAllCheckbox: _propTypes.default.bool,
  draggable: _propTypes.default.bool,
  thirdSortClick: _propTypes.default.bool,
  tooltip: _propTypes.default.string
};
const styles = theme => ({
  header: {
    // display: 'inline-block',
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: theme.palette.background.paper // Change according to theme,
  }
});
exports.styles = styles;
var _default = exports.default = (0, _withStyles.default)(styles, {
  withTheme: true
})(MTableHeader);